import { useCallback, useMemo } from 'react';
import useInfiniteFetch from '../useInfiniteFetch';
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
 import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import useQueryParams from '../../hooks/useQueryParams';
import { parseQueryToApiQuery } from 'src/utils/query.utils';
import ScriptExecutionService from '../../services/script-execution.service';
import { WDAC_SCRIPT_EXECUTION_AFFECTED_DEVICES_KEY } from '../../constants/query';

const useGetScriptExecutionAffectedDevices = ({ scriptExecutionId }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const {
    queryObject: { searchValue: initialSearchValue, filters = {} },
  } = useQueryParams();

  const query = useMemo(
    () =>
      parseQueryToApiQuery({
        filters,
        searchValue: initialSearchValue,
      }),
    [filters, initialSearchValue],
  );

  const fetchFunction = useCallback(
    ({ page, limit }) =>
      ScriptExecutionService.getScriptExecutionAffectedDevices({
        limit,
        page,
        scriptExecutionId,
        customerEnvId,
        query,
      }),
    [scriptExecutionId, customerEnvId, query],
  );

  const response = useInfiniteFetch({
    queryKey: [WDAC_SCRIPT_EXECUTION_AFFECTED_DEVICES_KEY, query, customerEnvId, scriptExecutionId],
    fetchFunction,
    expandedRowsLimit: EXPANDED_ROWS_LIMIT,
    itemName: 'devices',
  });

  return {
    ...response,
    query,
  };
};

export default useGetScriptExecutionAffectedDevices;
